import { createSlice } from '@reduxjs/toolkit'

export const exchangeSlice = createSlice({
	name: 'exchange',
	initialState: {
		isNeedToRemoveExchangeVariant: false,
		deleteId: null,
	},
	reducers: {
		setIsNeedToRemoveExchangeVariant: (state, { payload }) => {
			state.isNeedToRemoveExchangeVariant = true
			state.deleteId = payload
		},
		clearIsNeedToRemoveExchangeVariant: (state) => {
			state.isNeedToRemoveExchangeVariant = false
			state.deleteId = null
		},
	},
})

export const {
	setIsNeedToRemoveExchangeVariant,
	clearIsNeedToRemoveExchangeVariant,
} = exchangeSlice.actions
export const { reducer } = exchangeSlice
